// Standalone copy of mic-sounds/micCues.js (Option A). Keep in sync manually.
let ctx = null;

function getCtx() {
  if (!ctx) {
    const Ctor = window.AudioContext || window.webkitAudioContext;
    if (!Ctor) return null;
    ctx = new Ctor();
  }
  return ctx;
}

function tone(c, freq, at, dur, peak = 0.18) {
  const osc = c.createOscillator();
  const g = c.createGain();
  osc.type = "sine";
  osc.frequency.setValueAtTime(freq, at);
  g.gain.setValueAtTime(0, at);
  g.gain.linearRampToValueAtTime(peak, at + 0.008);
  g.gain.setValueAtTime(peak, at + Math.max(0.01, dur - 0.035));
  g.gain.linearRampToValueAtTime(0, at + dur);
  osc.connect(g);
  g.connect(c.destination);
  osc.start(at);
  osc.stop(at + dur + 0.02);
}

function play(render) {
  const c = getCtx();
  if (!c) return;
  const run = () => render(c, c.currentTime);
  if (c.state === "suspended") {
    c.resume().then(run).catch(() => {});
    return;
  }
  run();
}

export function playMicStartCueA() {
  play((c, t) => {
    tone(c, 660, t, 0.09);
    tone(c, 880, t + 0.12, 0.13);
  });
}

export function playMicStopCueA() {
  play((c, t) => {
    tone(c, 880, t, 0.09);
    tone(c, 660, t + 0.12, 0.15);
  });
}
